module.exports = __webpack_public_path__ + "static/media/delete-button.d4798137.svg";